import React, { ComponentType } from 'react';
import { HandoffTypes } from './handoff-metrics/handoff.constants';
import { HandoffFlowProps } from './handoff-flow.types';
import { ChecklistFlowConfig, ChecklistHandoffFlow } from './checklist-handoff-flow';
import { LegacyHandoffFlow } from './legacy-handoff-flow';
import { UnifyHandoffFlow } from './unify-handoff-flow';
import { VoiceAirHandoff } from './voice-air-handoff/voice-air-handoff';
import { mapChecklistMetricsToHandoffMetrics as mapVoiceAir } from './voice-air-handoff/voice-air-handoff.helpers';
import { MessagingAirHandoff } from './messaging-air-handoff/messaging-air-handoff';
import { mapChecklistMetricsToHandoffMetrics as mapMessagingAir } from './messaging-air-handoff/messaging-air-handoff.helpers';
import { WieHandoff } from './wie-handoff/wie-handoff';
import {
  mapChecklistMetricsToHandoffMetrics as mapWie,
  mapSnapshotMetricsToWieChecklist,
} from './wie-handoff/wie-handoff.helpers';

export type HandoffFlowKind = 'legacy' | 'checklist' | 'multiLocation';

const checklistFlow = (config: ChecklistFlowConfig) => (props: HandoffFlowProps) =>
  <ChecklistHandoffFlow {...props} config={config} />;

interface HandoffFlow {
  kind: HandoffFlowKind;
  EditFlow: ComponentType<HandoffFlowProps>;
  // Only offered when the location has sibling locations.
  requiresSiblings?: boolean;
}

const legacy: HandoffFlow = { kind: 'legacy', EditFlow: LegacyHandoffFlow };

const VoiceAirFlow = checklistFlow({
  Component: VoiceAirHandoff,
  mapMetrics: mapVoiceAir,
});
const MessagingAirFlow = checklistFlow({
  Component: MessagingAirHandoff,
  mapMetrics: mapMessagingAir,
});
const WieFlow = checklistFlow({
  Component: WieHandoff,
  mapMetrics: mapWie,
  getInitialMetrics: mapSnapshotMetricsToWieChecklist,
});

const flows: Partial<Record<HandoffTypes, HandoffFlow>> = {
  [HandoffTypes.VoiceAirHandoff]: { kind: 'checklist', EditFlow: VoiceAirFlow },
  [HandoffTypes.MessagingAirHandoff]: { kind: 'checklist', EditFlow: MessagingAirFlow },
  [HandoffTypes.WeaveInsuranceEligibility]: { kind: 'checklist', EditFlow: WieFlow },
  [HandoffTypes.OnboardingHandoffUnify]: {
    kind: 'multiLocation',
    EditFlow: UnifyHandoffFlow,
    requiresSiblings: true,
  },
};

export const getHandoffFlow = (type?: HandoffTypes): HandoffFlow =>
  type ? flows[type] ?? legacy : legacy;
